import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const SubmissionLimitsForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      initialValues={{
        limitSubmissions: {
          enabled: page.formDetails?.limitSubmissions?.enabled,
        },
      }}
      fields={() => [
        {
          name: 'limitSubmissions.enabled',
          required: false,
          type: 'checkbox',
          label: 'Prevent repeat submissions',
          helpText: 'Limit each lead to one submission of this form.',
        },
      ]}
      onSubmit={async (values, actions) => {
        const limitSubmissions = { enabled: values.limitSubmissions?.enabled === true };

        const { data, error } = await updatePage.mutateAsync({
          formDetails: {
            ...page.formDetails,
            limitSubmissions,
          },
        });

        if (data) {
          actions.resetForm({ values: { limitSubmissions } });
        }

        return { data, error };
      }}
    />
  );
};

export default SubmissionLimitsForm;
